import { render, staticRenderFns } from "./LiabilitiesEstatePlanning.vue?vue&type=template&id=b0f47f20"
import script from "./LiabilitiesEstatePlanning.vue?vue&type=script&lang=js"
export * from "./LiabilitiesEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports